import FavoriteButtonBox from './Common/FavoriteButtonBox.vue';
import ReportButtonBox from './Common/ReportButtonBox.vue';
import BaseModal from './Common/BaseModal.vue';
import NotificationBox from './Common/NotificationBox.vue';
import CampaignBanner from './modules/Banner/CampaignBanner.vue';
import ReportModal from './modules/Modal/ReportModal.vue';
import HistoricalChartComponent from './modules/Stocks/IR/HistoricalChart.vue';

/**
 * 個別銘柄ページのヘッダールートコンポーネント
 * @vue-components {FavoriteButtonBox} favoriteButtonBox お気に入りボタン
 * @vue-components {reportButtonBox} reportButtonBox PC用レポート銘柄ボタン
 * @vue-components {NotificationBox} notificationBox お知らせボックス
 * @vue-components {BaseModal} baseModal モーダル表示
 * @module IndividualFinancialItemIRHeader
 */
const IndividualFinancialItemIRHeader = {
  el: '#v-individual-financial-item-ir-header',
  data() {
    return {
      showModal: false,
      showButtons: false,
    };
  },
  components: {
    favoriteButtonBox: FavoriteButtonBox,
    reportButtonBox: ReportButtonBox,
    notificationBox: NotificationBox,
    baseModal: BaseModal,
    campaignBanner: CampaignBanner,
    ReportModal,
    historicalChart: HistoricalChartComponent,
  },
  mounted() {
    this.showButtons = true;
  },
  methods: {
    /**
     * モーダル表示イベント
     * @returns {boolean} closeイベントが発火するとshowModalはfalseとなる
     */
    showModalEvent: function () {
      this.showModal = true;
    },
  },
};

export default IndividualFinancialItemIRHeader;
